import React, { useState } from "react";
import { Link } from "react-router-dom";
import { segments } from "../mock";
import { ArrowRight, Home, Building2, Briefcase, Landmark, Users } from "lucide-react";

const icons = [Home, Building2, Briefcase, Landmark, Users];
const blurbs = [
  "Rent och skyddat tak på din villa – fast pris och ROT-avdrag direkt på fakturan.",
  "Helhetslösning för bostadsrättsföreningens alla tak, med tydlig dokumentation.",
  "Underhåll av tak på kontor, lager och industri – minimerar driftstopp.",
  "Systematiskt takunderhåll för hela fastighetsbeståndet.",
  "Gemensamma tak i samfälligheten – en kontakt, ett samlat pris.",
];

const actions = [
  { label: "Räkna på pris", href: "#kalkylator" },
  { label: "Boka fastighetsgenomgång", href: "/foretag" },
  { label: "Se företagslösningar", href: "/foretag" },
  { label: "Se fastighetslösningar", href: "/foretag" },
  { label: "Planera en gemensam TakKoll", href: "/foretag" },
];

export default function Segments() {
  const [active, setActive] = useState(0);
  const Icon = icons[active];
  const action = actions[active];
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 -mt-2 pt-14 sm:pt-16 pb-4">
        <div className="flex flex-wrap gap-2 rounded-2xl hpr-blue-tint p-2 ring-1 ring-[#dbeafe]">
          {segments.map((s, i) => {
            const TabIcon = icons[i];
            return (
              <button
                key={s}
                onClick={() => setActive(i)}
                data-testid={`segment-tab-${i}`}
                aria-pressed={active === i}
                className={`flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-semibold transition-all ${
                  active === i ? "bg-[#1B45C4] text-white shadow-md shadow-[#1B45C4]/25" : "text-slate-600 hover:bg-white"
                }`}
              >
                <TabIcon className="w-4 h-4" /> {s}
              </button>
            );
          })}
        </div>
        <div className="mt-4 flex items-start gap-4 rounded-2xl bg-[#1B45C4]/[0.04] p-6 ring-1 ring-[#1B45C4]/10">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#1B45C4]/10">
            <Icon className="w-6 h-6 text-[#1B45C4]" />
          </div>
          <div className="min-w-0">
            <h3 className="text-lg font-bold text-slate-900">{segments[active]}</h3>
            <p className="text-slate-600">{blurbs[active]}</p>
            {action.href.startsWith("/") ? (
              <Link to={action.href} data-testid="segment-action-link" className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#1B45C4] transition-colors hover:text-[#12308f]">{action.label}<ArrowRight className="h-4 w-4" /></Link>
            ) : (
              <a href={action.href} data-testid="segment-action-link" className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#1B45C4] transition-colors hover:text-[#12308f]">{action.label}<ArrowRight className="h-4 w-4" /></a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
